export default __webpack_public_path__ + "static/media/brand_personality.596871f9.svg";